import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    IconButton,
    Paper,
    Table,
    TableBody,
    Tooltip,
} from "@material-ui/core";

import AddIcon from "@material-ui/icons/Add";
import Boton from "./Boton";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ExpandMore from "@material-ui/icons/ExpandMore";
import WebIcon from "@material-ui/icons/Web";
import { useLogin } from "../../../../context/LoginContext";
import { useSistema } from "../../../../context/SistemaContext";
import { useStyle } from "../../../../context/StyleContext";

export default function Submodulo(props) {
    const { submodulo } = props;

    const { classes } = useStyle();
    const { usuarioPermisos } = useLogin();
    const { handleClickEditarSubmodulo, handleClickEliminarSubmodulo, handleClickNuevoBoton } = useSistema();

    const colorClass = "color-2";
    const permisos = usuarioPermisos["1"].Submodulos["3"];

    return (
        <Accordion elevation={0} classes={{ root: classes.hideLineAcc }}>
            <AccordionSummary
                expandIcon={
                    <Tooltip title={`Mostrar/Ocultar botones de ${submodulo.sNombre}`} placement="top-end" arrow>
                        <ExpandMore className={colorClass} />
                    </Tooltip>
                }
                classes={{ content: classes.marginAccSub }}
            >
                <div className="align-self-center flx-grw-1">
                    <WebIcon className={colorClass + " vertical-align-middle"} />
                    <span className={colorClass + " size-15"}>
                        {submodulo.sNombre} ({submodulo.iIdSubModulo})
                    </span>
                </div>
                {permisos.Botones["6"] !== undefined && ( //Editar el submódulo
                    <Tooltip title={`${permisos.Botones["6"].Nombre} ${submodulo.sNombre}`} placement="top" arrow>
                        <IconButton onClick={(e) => handleClickEditarSubmodulo(e, submodulo)}>
                            <EditIcon className={colorClass} />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["7"] !== undefined && ( //Eliminar el submódulo
                    <Tooltip title={`${permisos.Botones["7"].Nombre} ${submodulo.sNombre}`} placement="top" arrow>
                        <IconButton onClick={(e) => handleClickEliminarSubmodulo(e, submodulo)}>
                            <DeleteIcon className={colorClass} />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["8"] !== undefined && ( //Agregar un botón nuevo a
                    <Tooltip title={`${permisos.Botones["8"].Nombre} ${submodulo.sNombre}`} placement="top" arrow>
                        <IconButton onClick={(e) => handleClickNuevoBoton(e, submodulo)}>
                            <AddIcon className={colorClass} />
                        </IconButton>
                    </Tooltip>
                )}
            </AccordionSummary>
            <AccordionDetails>
                <div className="acc-content">
                    <Paper elevation={0}>
                        <Table size="small">
                            <TableBody>
                                {submodulo.lstBotones.length > 0 ? (
                                    submodulo.lstBotones.map((boton) => <Boton key={boton.iIdBoton} boton={boton} />)
                                ) : (
                                    <div className="center">(No hay botones configurados para este submódulo)</div>
                                )}
                            </TableBody>
                        </Table>
                    </Paper>
                </div>
            </AccordionDetails>
        </Accordion>
    );
}
